import { createContext } from 'react'

import { AppConfig } from './types.d'

const AppConfigContext = createContext<AppConfig.Config>({})

export default AppConfigContext
